import React, {useState} from "react";
import {Button, Input} from "@material-tailwind/react";
import {BsEyeFill} from "react-icons/bs";

const PasswordField = ({className, label, onChange}) => {

  const [showPassword, setShowPassword] = useState(false)

  return (
    <div className="relative flex  mb-4 w-full">
      <Input variant="standard"
             type={showPassword ? "text" : "password"}
             label={label}
             placeholder={label}
             onChange={(e) => {
               onChange(e.target.value)
             }}
      />
      <Button
        size="sm"
        onClick={() => setShowPassword(!showPassword)}
        className="!absolute left-0 top-1 rounded-2xl bg-gray-100 text-gray-800"
      >
        <BsEyeFill/>
      </Button>
    </div>
  );
};

export default PasswordField;
